import createReactClass from "create-react-class";
import PropTypes from "prop-types";

const TRIGGER_OFFSET_RATIO = 0.2;
const UNTRIGGER_OFFSET_RATIO = 0.4;

var WindowScrollListener = createReactClass({
  propTypes: {
    onScrollEnd: PropTypes.func,
  },

  getInitialState() {
    return {
      triggered: false,
    };
  },

  handleScroll: function (event) {
    // Call the passed-in prop
    // if (this.props.onWindowScroll) this.props.onWindowScroll(event);

    const offset = window.innerHeight * TRIGGER_OFFSET_RATIO;
    if (
      !this.state.triggered &&
      window.innerHeight + window.scrollY >= document.body.offsetHeight - offset
    ) {
      console.info("Scroll End");

      this.setState({ triggered: true });
      // you're at the bottom of the page
      if (this.props.onScrollEnd) this.props.onScrollEnd(event);
    }

    const unTriggerOffset = window.innerHeight * UNTRIGGER_OFFSET_RATIO;

    if (
      this.state.triggered &&
      window.innerHeight + window.scrollY <=
        document.body.offsetHeight - unTriggerOffset
    ) {
      this.setState({ triggered: false });

      console.info("Scroll End Reset");
    }
  },

  render: function () {
    return this.props.children || null;
  },

  componentDidMount: function () {
    window.addEventListener("scroll", this.handleScroll);
  },

  componentWillUnmount: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
});

export default WindowScrollListener;
